import {
    get_incassi,
    get_incasso,
    create_incasso,
    update_incasso,
    completa_incasso,
    duplica_incasso,
    elimina_incasso,
} from "@/api/api.incasso.js";

const incassi = {
    namespaced: true,

    state: {
        lista: [],
        corrente: null,
    },

    mutations: {
        SET_LISTA: (state, lista) => {
            state.lista = lista;
        },
        SET_CORRENTE: (state, i) => {
            state.corrente = i;
        },
    },

    actions: {
        carica({ commit }, filtri) {
            return new Promise((resolve, reject) => {
                get_incassi(filtri).then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaDettaglio({ commit }, id) {
            return new Promise((resolve, reject) => {
                get_incasso(id).then(resp => {
                    commit("SET_CORRENTE", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salva({ dispatch }, { id, dati, filtri }) {
            const call = id ? update_incasso(id, dati) : create_incasso(dati);
            return new Promise((resolve, reject) => {
                call.then(resp => {
                    dispatch("carica", filtri);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        completa({ dispatch }, { id, dati, filtri }) {
            return new Promise((resolve, reject) => {
                completa_incasso(id, dati).then(resp => {
                    dispatch("carica", filtri);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        elimina({ dispatch }, { id, filtri }) {
            return new Promise((resolve, reject) => {
                elimina_incasso(id).then(resp => {
                    dispatch("carica", filtri);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        duplica({ dispatch }, { id, filtri }) {
            return new Promise((resolve, reject) => {
                duplica_incasso(id).then(resp => {
                    dispatch("carica", filtri);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
        corrente: state => state.corrente,
    },
};

export default incassi;
